/**
 * @description Activate or deactivate the elements with the attribute data-class-active.
 * @param {HTMLElement} domElement - The container where the logic will happen.
 */
export default class MenuTrigger {
    constructor(domElement) {
        if(!domElement) {
            throw new Error('domElement doesn\'t exist');
        }
        this.activeClassAttr = 'data-class-active';

        const domActiveTriggerList = [...domElement.querySelectorAll('[data-trigger-active]')];
        const domInactiveTriggerList = [...domElement.querySelectorAll('[data-trigger-inactive]')];
        const domItemsToTriggerList = [...domElement.querySelectorAll(`[${this.activeClassAttr}]`)];

        this.config = {
            domActiveTriggerList,
            domElement,
            domInactiveTriggerList,
            domItemsToTriggerList
        };

        this.checkParameters();

        domElement.dataset.menuTriggerInitialized = 'true';

        this.initListeners();
    }

    checkParameters() {
        if(this.config.domActiveTriggerList.length === 0 || this.config.domInactiveTriggerList.length === 0) {
            throw new Error('the data-trigger-active or/and data-trigger-inactive attribute is missing');
        }

        if(!this.config.domItemsToTriggerList.length) {
            throw new Error('the data-class-active attribute is missing');
        }

        if(this.config.domElement.dataset.menuTriggerInitialized) {
            throw new Error('The MenuTrigger is already initialized');
        }
    }

    /**
     * @description Add the value to the data-class-active attribute to the elements.
     */
    MenuTriggerActivation() {
        this.config.domItemsToTriggerList.forEach(domItem => {
            domItem.classList.add(domItem.getAttribute(this.activeClassAttr));
        });
    }

    /**
     * @description Remove the value to the data-class-active attribute to the elements.
     */
    MenuTriggerDeactivation() {
        this.config.domItemsToTriggerList.forEach(domItem => {
            domItem.classList.remove(domItem.getAttribute(this.activeClassAttr));
        });
    }

    /**
     * @description Attach the event to the triggers.
     */
    initListeners() {
        this.config.domActiveTriggerList.forEach(domItem => {
            domItem.addEventListener('click', this.MenuTriggerActivation.bind(this));
        });

        this.config.domInactiveTriggerList.forEach(domItem => {
            domItem.addEventListener('click', this.MenuTriggerDeactivation.bind(this));
        });
    }
}
